import { Provider } from 'react-redux';

import RouterProvider from './routes';
import { ThemeProvider } from '@mui/material/styles';
import SettingsProvider from './components/Settings/components/SettingsProvider';

import theme from './overrides/theme';
import store from './store';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import SentryProvider from './components/Sentry/sentry';
import LanguageProvider from './languages/providers/LanguageProvider';
import ErpFeaturesProvider from './components/ErpFeatures/components/ErpFeaturesProvider';
import ProfileProvider from './components/User/ProfileProvider';



const queryClient = new QueryClient();

const App = (props) => {
  
  return (
    <SentryProvider>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <ErpFeaturesProvider>
            <SettingsProvider>
              <ProfileProvider>
                <LanguageProvider>
                  <ThemeProvider theme={theme}>
                    <RouterProvider />
                  </ThemeProvider>
                </LanguageProvider>
              </ProfileProvider>
            </SettingsProvider>
          </ErpFeaturesProvider>
        </Provider>
      </QueryClientProvider>
    </SentryProvider>
  );
};

export default App;
